var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"id":"request","to":{name: 'require'}}},[_vm._v("发布需求")])}
var staticRenderFns = []

export { render, staticRenderFns }